import { gql } from '@apollo/client';

export const DELETE_PENALTY = gql`
  mutation DeletePenalty($id: Int!) {
    delete_penalties_by_pk(id: $id) {
      id
    }
  }
`;

export const INSERT_PENALTY = gql`
  mutation InsertPenalty($penalty: penalties_insert_input!) {
    insert_penalties_one(object: $penalty) {
      id
    }
  }
`;
